import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TelefoneMaskDirective } from './telefone-mask.directive';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ TelefoneMaskDirective ],
    exports: [ TelefoneMaskDirective ],
})
export class TelefoneMaskDirectiveModule {}
